import { createFileRoute } from "@tanstack/react-router";
import GutterRepairs from "@/pages/services/GutterRepairs";
import { seo, breadcrumbSchema, absoluteUrl } from "@/lib/seo";
import { buildFaqPageSchema, buildServiceSchema } from "@/lib/schema";
import { gutterRepairFaqs } from "@/data/serviceFaqs";

export const Route = createFileRoute("/_site/services/gutter-repairs")({
  head: () =>
    seo({
      title: "Gutter Repair in Minneapolis, MN | Cedar Creek Construction",
      description:
        "Gutter repair in Minneapolis & the Twin Cities—leaks, sagging, loose gutters, and downspouts. Keep water away from your foundation. Call (612) 298-9865.",
      path: "/services/gutter-repairs",
      jsonLd: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Services", path: "/gutters" },
          { name: "Gutter Repairs", path: "/services/gutter-repairs" },
        ]),
        buildServiceSchema({
          name: "Gutter Repair in Minneapolis, MN",
          serviceType: "Gutter Repair",
          url: absoluteUrl("/services/gutter-repairs"),
          description:
            "Gutter repair for leaks, sagging, loose gutters, and downspout problems on homes across Minneapolis and the Twin Cities metro.",
        }),
        buildFaqPageSchema(gutterRepairFaqs),
      ],
    }),
  component: GutterRepairs,
});
